export const products = [
  {
    sku: 'berry-blast-16oz',
    name: 'Berry Blast',
    tag: 'Signature Juice • 16oz',
    category: 'juice',
    description: 'Strawberry, blueberry, and raspberry fusion with beet for natural sweetness. Cold-pressed with no added sugars. 16oz bottle.',
    price: 3.99,
    container: 'bottle-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/fq3mktus_Berry%20blast.png',
    metaPill: 'Best Seller',
    size: '16oz',
    calories: 120
  },
  {
    sku: 'citrus-sunrise-16oz',
    name: 'Citrus Sunrise',
    tag: 'Morning Energy • 16oz',
    category: 'juice',
    description: 'Fresh-squeezed orange, grapefruit, and lemon with a hint of ginger. Start your morning right. 16oz bottle.',
    price: 3.99,
    container: 'bottle-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/s5ufn8v5_Citrus%20Sunrise.png',
    metaPill: 'Morning Boost',
    size: '16oz',
    calories: 110
  },
  {
    sku: 'green-power-16oz',
    name: 'Green Power',
    tag: 'Vitamin Boost • 16oz',
    category: 'juice',
    description: 'Kale, spinach, cucumber, apple, and lemon. Nutrient-dense green juice for vitality and wellness. 16oz bottle.',
    price: 3.99,
    container: 'bottle-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/9xezkzvw_Green%20drinks.png',
    metaPill: 'Vitamin Power',
    size: '16oz',
    calories: 95
  },
  {
    sku: 'midnight-orchard-16oz',
    name: 'Midnight Orchard',
    tag: 'Dark Berry • 16oz',
    category: 'juice',
    description: 'Blackberries, dark cherries, and elderberry. Rich in antioxidants, perfect for evening relaxation. 16oz jar.',
    price: 3.99,
    container: 'jar-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/325i67pr_Midnight%20Orchard.png',
    metaPill: 'Night Mode',
    size: '16oz',
    calories: 130
  },
  {
    sku: 'tropical-tangy-16oz',
    name: 'Tropical Tangy',
    tag: 'Island Escape • 16oz',
    category: 'juice',
    description: 'Mango, pineapple, passion fruit, and coconut water. Transport yourself to paradise. 16oz jar.',
    price: 3.99,
    container: 'jar-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/xllt07u7_Tropical%20Tangy.png',
    metaPill: 'Tropical',
    size: '16oz',
    calories: 140
  },
  {
    sku: 'pine-hills-phoenix-16oz',
    name: 'Pine Hills Phoenix',
    tag: 'Recovery Blend • 16oz',
    category: 'juice',
    description: 'Carrot, orange, turmeric, and ginger. Anti-inflammatory recovery blend for post-workout or morning reset. 16oz bottle.',
    price: 3.99,
    container: 'bottle-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/8hfqdtgv_fff57da0-f4b3-4d71-96af-f057b872112b.jpg',
    metaPill: 'Recovery',
    size: '16oz',
    calories: 105
  },
  {
    sku: 'tea-pouch-variety-pack',
    name: 'Tea Pouch Variety Pack',
    tag: 'Premium Tea • 6 Pouches',
    category: 'tea',
    description: 'Herbal blend tea pouches featuring chamomile, green tea, and ginger lemon. 6 pouches per pack. Shipping included.',
    price: 3.99,
    container: 'pouch-pack',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/k79fygdk_Pouches.png',
    metaPill: 'Chill Mode',
    size: '6-pack',
    servings: 6
  },
  {
    sku: 'mocktail-mixer-lite-16oz',
    name: 'Mixed Drink - Citrus Lite',
    tag: '16oz Bottle',
    category: 'mixed-drink',
    description: 'Mixed Drink with light citrus blend. 16oz bottle. Shipping included.',
    price: 5.99,
    container: 'bottle-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/8hfqdtgv_fff57da0-f4b3-4d71-96af-f057b872112b.jpg',
    metaPill: 'Party Ready',
    size: '16oz',
    servings: '4-6',
    ageRestricted: true
  },
  {
    sku: 'classic-mixer-16oz',
    name: 'Mixed Drink - Classic',
    tag: '16oz Bottle',
    category: 'mixed-drink',
    description: 'Mixed Drink with premium fruit blend. 16oz bottle. Shipping included.',
    price: 5.99,
    container: 'bottle-16oz',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/8hfqdtgv_fff57da0-f4b3-4d71-96af-f057b872112b.jpg',
    metaPill: 'Event Mode',
    size: '16oz',
    servings: '4-6',
    ageRestricted: true
  },
  {
    sku: 'party-pack-4-mixers',
    name: 'Mixed Drinks Party Pack',
    tag: 'Bundle • 4x16oz',
    category: 'bundle',
    description: 'Four 16oz Mixed Drink bottles. Perfect for gatherings. Shipping included in price.',
    price: 20,
    container: 'bundle-4pack',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/zn9nzgtx_Screenshot%202025-11-19%20220451.png',
    metaPill: 'Best Value',
    size: '4x16oz',
    servings: '16-24',
    ageRestricted: true
  },
  {
    sku: 'teeaze-classic-tee-white',
    name: 'TEEAZE Classic Tee - White',
    tag: 'Premium Cotton • Unisex',
    category: 'tee',
    description: 'Premium 100% cotton tee featuring the iconic TEEAZE N SHOTZ retro logo. White colorway. Unisex sizing. Shipping included.',
    price: 24.99,
    container: 'apparel',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/oeqw3dpb_ChatGPT%20Image%20Nov%2020%2C%202025%2C%2001_44_25%20AM.png',
    metaPill: 'Classic',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    colorway: 'White'
  },
  {
    sku: 'teeaze-classic-tee-pink',
    name: 'TEEAZE Classic Tee - Pink',
    tag: 'Premium Cotton • Unisex',
    category: 'tee',
    description: 'Premium 100% cotton tee featuring the iconic TEEAZE N SHOTZ retro logo. Hot pink colorway. Unisex sizing. Shipping included.',
    price: 24.99,
    container: 'apparel',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/gb4npd3a_ChatGPT%20Image%20Nov%2020%2C%202025%2C%2001_44_41%20AM.png',
    metaPill: 'Bold',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    colorway: 'Hot Pink'
  },
  {
    sku: 'teeaze-mixer-design-green',
    name: 'TEEAZE Mixer Tee - Green',
    tag: 'Limited Edition • Unisex',
    category: 'tee',
    description: 'Exclusive design featuring juice cup splash with TEEAZE N SHOTZ logo. Premium cotton. Green colorway. Shipping included.',
    price: 24.99,
    container: 'apparel',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/w4oczvio_Green%20Tee.png',
    metaPill: 'Limited',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    colorway: 'Green'
  },
  {
    sku: 'teeaze-mixer-variety-pack',
    name: 'TEEAZE Mixer Tee Collection',
    tag: 'Limited Edition • Multiple Colors',
    category: 'tee',
    description: 'Exclusive mixer bottle design collection. Available in Green, Orange, Red, and White. Each features unique juice splash graphics with TEEAZE N SHOTZ branding. Shipping included.',
    price: 24.99,
    container: 'apparel',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/9iz44lvg_Mixer%20Tees%20Variety.png',
    metaPill: 'Variety',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    colorway: 'Multiple'
  },
  {
    sku: 'teeaze-hoodie-black',
    name: 'TEEAZE Hoodie - Black',
    tag: 'Premium Fleece • Unisex',
    category: 'hoodie',
    description: 'Premium heavyweight fleece hoodie with iconic TEEAZE N SHOTZ retro logo. Kangaroo pocket, drawstring hood. Black colorway. Unisex sizing. Shipping included.',
    price: 29.99,
    container: 'apparel',
    image: 'https://customer-assets.emergentagent.com/job_drinkstack/artifacts/mxfe2kmo_ChatGPT%20Image%20Nov%2020%2C%202025%2C%2001_58_32%20AM.png',
    metaPill: 'Cozy',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    colorway: 'Black'
  }
];

export const subscriptions = [
  {
    id: 'energy',
    name: 'ENERGY Club',
    price: 25,
    interval: 'month',
    tier: 1,
    description: 'Start your journey with essential fuel',
    features: [
      '2 juices + 2 shots (shipping included)',
      '1 digital Tee design',
      'Access to private SMS drops',
      'Cancel anytime',
      'Exclusive member perks'
    ]
  },
  {
    id: 'vibes',
    name: 'VIBES Club',
    price: 45,
    interval: 'month',
    tier: 2,
    description: 'Level up with physical merch + more fuel',
    features: [
      '4 juices + 4 shots (shipping included)',
      '1 physical Tee',
      'Early access to new flavors',
      'Priority delivery',
      'Member-only discounts',
      'SMS drop alerts'
    ],
    popular: true
  },
  {
    id: 'luxe',
    name: 'LUXE Club',
    price: 75,
    interval: 'month',
    tier: 3,
    description: 'The complete lifestyle experience',
    features: [
      '6 juices + 6 shots (shipping included)',
      'Monthly Tee',
      'Mixed drink kit',
      'Pop-up + event invites',
      'Express delivery',
      'VIP customer support',
      'Quarterly bonus merch',
      '🔒 Pioneer: Lifetime locked-in price'
    ],
    pioneer: true
  },
  {
    id: 'godlevel',
    name: 'GOD LEVEL',
    price: 150,
    interval: 'month',
    tier: 4,
    description: 'Elite status—for those who move legendary',
    features: [
      'Full detox kit (shipping included)',
      'Monthly Tee + Hoodie',
      'Private party invites',
      'Catering credit included',
      'Name on Pioneers wall',
      'Personal concierge service',
      'Unlimited flavor swaps',
      '🔒 Pioneer: Lifetime locked-in price'
    ],
    comingSoon: true,
    pioneer: true
  }
];